import type {
    TradeInAemFindVehicleStatus,
    TradeInAemResolveItemConfig,
    TradeInAemResolveVehicleType,
    TradeInAemVehicleType,
} from "../../utils/types";
import type { TradeInAemSearchType } from "../../utils/constants";

export const TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_RESULTS = "tradeInAemFindVehicle/setSearchResults";
export type TradeInAemFindVehicleSetResults = {
    type: typeof TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_RESULTS;
    searchResults: TradeInAemVehicleType[];
    status?: TradeInAemFindVehicleStatus;
};
export const tradeInAemFindVehicleSetSearchResults = (
    searchResults: TradeInAemVehicleType[],
    status?: TradeInAemFindVehicleStatus,
): TradeInAemFindVehicleSetResults => ({
    type: TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_RESULTS,
    searchResults,
    status,
});

export const TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_VALUE = "tradeInAemFindVehicle/setSearchValue";
export type TradeInAemFindVehicleSetSearch = {
    type: typeof TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_VALUE;
    searchValue: string;
    searchType: TradeInAemSearchType;
};
export const tradeInAemSetSearchValue = (
    searchValue: string,
    searchType: TradeInAemSearchType,
): TradeInAemFindVehicleSetSearch => ({
    type: TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_VALUE,
    searchValue,
    searchType,
});

export const TRADE_IN_AEM_SET_RESOLVE_VEHICLE = "tradeInAemFindVehicle/setResolveVehicle";
export type TradeInAemSetResolveVehicle = {
    type: typeof TRADE_IN_AEM_SET_RESOLVE_VEHICLE;
    resolveVehicle: TradeInAemResolveVehicleType;
};
export const tradeInAemSetResolveVehicle = (
    resolveVehicle: TradeInAemResolveVehicleType,
): TradeInAemSetResolveVehicle => ({
    type: TRADE_IN_AEM_SET_RESOLVE_VEHICLE,
    resolveVehicle,
});

export const TRADE_IN_AEM_SET_RESOLVE_LOADING = "tradeInAemFindVehicle/setResolveLoading";
export type TradeInAemSetResolveLoading = {
    type: typeof TRADE_IN_AEM_SET_RESOLVE_LOADING;
    loading: boolean;
};
export const tradeInAemSetResolveLoading = (loading: boolean): TradeInAemSetResolveLoading => ({
    type: TRADE_IN_AEM_SET_RESOLVE_LOADING,
    loading,
});

export const TRADE_IN_AEM_SELECT_RESOLVE_ITEM = "tradeInAemFindVehicle/selectResolveItem";
export type TradeInAemSelectResolveItem = {
    type: typeof TRADE_IN_AEM_SELECT_RESOLVE_ITEM;
    itemKey: string;
    optionId: string;
};
export const tradeInAemSelectResolveItem = (itemKey: string, optionId: string): TradeInAemSelectResolveItem => ({
    type: TRADE_IN_AEM_SELECT_RESOLVE_ITEM,
    itemKey,
    optionId,
});

export const TRADE_IN_AEM_RESET_RESOLVE_ITEMS = "tradeInAemFindVehicle/resetResolveItems";
export type TradeInAemResetResolveItems = {
    type: typeof TRADE_IN_AEM_RESET_RESOLVE_ITEMS;
    itemKeys: string[];
};
export const tradeInAemResetResolveItems = (itemKeys: string[]): TradeInAemResetResolveItems => ({
    type: TRADE_IN_AEM_RESET_RESOLVE_ITEMS,
    itemKeys,
});

export const TRADE_IN_AEM_ADD_RESOLVE_ITEM = "tradeInAemFindVehicle/addResolveItem";
export type TradeInAemAddResolveItem = {
    type: typeof TRADE_IN_AEM_ADD_RESOLVE_ITEM;
    item: TradeInAemResolveItemConfig;
};
export const tradeInAemAddResolveItem = (item: TradeInAemResolveItemConfig): TradeInAemAddResolveItem => ({
    type: TRADE_IN_AEM_ADD_RESOLVE_ITEM,
    item,
});

export const TRADE_IN_AEM_SET_RESOLVE_FAILED = "tradeInAemFindVehicle/setResolveFailed";
export type TradeInAemSetResolveFailed = {
    type: typeof TRADE_IN_AEM_SET_RESOLVE_FAILED;
    failed: boolean;
};
export const tradeInAemSetResolveFailed = (failed: boolean): TradeInAemSetResolveFailed => ({
    type: TRADE_IN_AEM_SET_RESOLVE_FAILED,
    failed,
});

export type TradeInAemFindVehicleActionsType =
    | TradeInAemFindVehicleSetResults
    | TradeInAemFindVehicleSetSearch
    | TradeInAemSetResolveVehicle
    | TradeInAemSetResolveLoading
    | TradeInAemSelectResolveItem
    | TradeInAemAddResolveItem
    | TradeInAemResetResolveItems
    | TradeInAemSetResolveFailed;
